import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { ValidationLimits } from "web_myplann/Shared/Validation/validationLimits";
import { z } from "zod";

export const getValueFormSchema = (t: TranslateFunction) =>
	z.object({
		value: z
			.number({
				required_error: t(Resources.Portfolio.AddShared.Validations.required),
				invalid_type_error: t(
					Resources.Portfolio.AddShared.Validations.required,
				),
			})
			.gt(
				0,
				t(Resources.PortfolioDetail.SharedLabels.ValueDrawer.positiveValue),
			)
			.max(
				ValidationLimits.Amount.Max,
				t(Resources.Portfolio.AddShared.Validations.maxValue),
			),
	});

export type ValueFormModel = z.infer<ReturnType<typeof getValueFormSchema>>;
